var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"14px"}},[(_vm.noMore_)?_c('span',[_vm._v("没有更多了")]):_c('el-button',{attrs:{"loading":_vm.nextLoading,"type":"primary","size":"mini","round":""},on:{"click":_vm.loadNext}},[_vm._v("加载更多 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }